<template>
    <canvas ref="chart" width="100" height="100" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Chart, type TooltipItem } from "./chart";

const chart = ref<HTMLCanvasElement | null>(null);
const parameters: any = {
    type: "bar",
    data: {
        labels: ["Less Abdominal Bloating", "Less Heartburn", "Less Fatigue"],
        datasets: [
            {
                label: "Hepagard",
                data: [96.67, 96.67, 83.33],
                backgroundColor: [
                    "rgba(0, 192, 0, 0.3)",
                    "rgba(0, 192, 0, 0.3)",
                    "rgba(0, 192, 0, 0.3)",
                ],
                borderColor: [
                    "rgba(0, 192, 0, 1)",
                    "rgba(0, 192, 0, 1)",
                    "rgba(0, 192, 0, 1)",
                ],
                borderWidth: 1,
            },
            {
                label: "Placebo",
                data: [30, 40, 25],
                backgroundColor: [
                    "rgba(24, 140, 251, 0.3)",
                    "rgba(24, 140, 251, 0.3)",
                    "rgba(24, 140, 251, 0.3)",
                ],
                borderColor: [
                    "rgba(24, 140, 251, 1)",
                    "rgba(24, 140, 251, 1)",
                    "rgba(24, 140, 251, 1)",
                ],
                borderWidth: 1,
            },
        ],
    },
    options: {
        indexAxis: "y",
        scales: {
            x: {
                beginAtZero: true,
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context: TooltipItem<"bar">) {
                        return `${context.dataset.label} - ${context.formattedValue}%`;
                    },
                },
            },
        },
    },
};

onMounted(() => {
    if (chart.value) {
        new Chart(chart.value, parameters);
    }
});
</script>
